export interface Joke {
  setup: string
  punchline: string
  citation: string
}

export const BOOK_JOKES: Joke[] = [
  {
    setup: 'What is the best way to catch a school of fish?',
    punchline: 'With bookworms!',
    citation: 'Dad Jokes: The Good, the Bad, And The Just Plain Stupid by Joshua Shifrin',
  },
  {
    setup: 'Why did the book join the police?',
    punchline: 'It wanted to work undercover!',
    citation: 'Classic Book Jokes',
  },
  {
    setup: 'What do you call a book that\'s been in the sun too long?',
    punchline: 'Well red!',
    citation: 'Library Laughs',
  },
  {
    setup: 'Why are books so good at keeping secrets?',
    punchline: 'Because they\'re always closed!',
    citation: 'Bookworm Humor',
  },
  {
    setup: 'What building has the most stories?',
    punchline: 'The library!',
    citation: 'Classic Kids Jokes',
  },
]
